import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledText = styled.small `
    color: rgb(41, 48, 87, 0.4);
    font-size: 12px;
`;
const HelperText = ({ children, ...props }) => (_jsx(StyledText, { ...props, children: children }));
export default HelperText;
